<template>
  <EditorPanel class="pb-empty-panel">
    <template
      v-if="title"
      #header
    >
      <h3>{{ title }}</h3>
    </template>
    <PanelMessage v-if="message">
      {{ translate(message) }}
    </PanelMessage>
  </EditorPanel>
</template>

<script setup>
import EditorPanel from '@/components/EditorPanel/EditorPanel.vue'
import PanelMessage from '@/components/PanelMessage/PanelMessage.vue'
import useTranslate from '@/composables/useTranslate'

const { translate } = useTranslate()

defineProps({
  title: { type: String, default: '' },
  message: { type: String, default: '' },
})
</script>

<style lang="scss">
@use '@nicolaudie-group/ng-ui-kit/defines/_fonts.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_colors.define.scss';
@use '@nicolaudie-group/ng-ui-kit/defines/_config.define.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_flexbox.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_generic.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_responsive.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_theme.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_animations.mixin.scss';
@use '@nicolaudie-group/ng-ui-kit/mixins/_transitions.mixin.scss';

@use '/src/styles/_pb.scss';

.pb-empty-panel {
  .pb-panel-header {
    padding: pb.$spacing pb.$spacing 0 pb.$spacing;
  }
}
</style>
